import { extendTheme } from "@chakra-ui/react";
import Button from "./Button";
import Heading from "./Heading";
import Text from "./Text";
import Input from "./Input";
import NumberInput from "./NumberInput";
import Select from "./Select";
import Form from "./Form";
import FormLabel from "./FormLabel";
import Alert from "./Alert";
import Radio from "./Radio";
import Modal from "./Modal";
import Textarea from "./Textarea";
import Badge from "./Badge";
import Table from "./Table";
import Menu from "./Menu";
import Tabs from "./Tabs";
import Switch from "./Switch";
import "@fontsource/inter";
import Divider from "./Divider";

const theme = extendTheme({
  colors: {
    primary: "#1a2b58", // Custom primary color
    secondary: "#00b1dd",
    textPrimary: "#272A2A",
    textSecondary: "#717A7A",
    textDisabled: "#A5ABAB",
    // secondary: '#FF6347',  // Custom secondary color
    // background: '#F0F0F0', // Background color
    // text: '#333333',       // Text color
    // brand: {
    //   50: '#e5f4ff',
    //   100: '#c1e1ff',
    //   200: '#99c9ff',
    //   300: '#66aaff',
    //   400: '#3388ff',
    //   500: '#0066cc',     // Main brand color
    //   600: '#0059b3',
    //   700: '#004d99',
    //   800: '#003d80',
    //   900: '#002c66',
    // },
    gray: {
      150: "#EEF0F0",
    },
    blue: {
      100: "#e3f4ff",
      500: "#1a2b58",
    },
  },
  fonts: {
    heading: `"Inter", sans-serif`,
    body: `"Inter", sans-serif`,
  },
  styles: {
    global: () => ({
      body: {
        color: "darkestBlue",
      },
    }),
  },
  fontSizes: {
    sm: "12px",
    md: "14px",
  },
  radii: {
    sm: "4px",
    md: "8px",
    lg: "16px",
    xl: "24px",
  },
  components: {
    Button,
    Heading,
    Text,
    Input,
    NumberInput,
    Select,
    Textarea,
    Form,
    FormLabel,
    Alert,
    Radio,
    Modal,
    Badge,
    Table,
    Menu,
    Tabs,
    Switch,
    Divider,
  },
});

export default theme;
